import React from 'react';

const Features = () => {
    return (
        <div id="features" className="features">
            <h1>Our Features</h1>
            <ul>
                <li>
                    <strong>Secure Transactions:</strong> We prioritize security to keep your data and finances safe.
                </li>
                <li>
                    <strong>Real-Time Analytics:</strong> Get insights and analytics to make informed decisions instantly.
                </li>
                <li>
                    <strong>Scalable Solutions:</strong> Our platform grows with your needs, offering flexible features.
                </li>
                <li>
                    <strong>Global Accessibility:</strong> Access your finances from anywhere, anytime.
                </li>
            </ul>
        </div>
    );
};

export default Features;
